//
// Log messages to the console.
function AdsNinjaVideoPlayerEngagementHelper(element, engagementThesholds, callback){

    this.__isTrackingEngagement       = false;
    this.__engagementTime             = 0;
    this.__trackingTimeStart          = null;
    this.__minEngagementTimeTracked   = null;
    this.__maxEngagementTimeTracked   = null;
    this.__engagementThesholds        = [];
    this.__element                    = element;
    this.__callback                   = callback;

    if(!element || !callback || typeof callback !== 'function'){

        throw new Error('Invalid arguments passed to constructor.');
    }

    this.__setEngagementThesholds(engagementThesholds);
}

//
// Start tracking.
AdsNinjaVideoPlayerEngagementHelper.prototype.startTracking = function(){
    
    if(this.__isTrackingEngagement){

        return;
    }

    this.__isTrackingEngagement = true;
    this.__trackingTimeStart    = new Date();
}

//
// Stop tracking.
AdsNinjaVideoPlayerEngagementHelper.prototype.stopTracking = function(){

    this.__engagementTime       += this.__getCurrentEngagementTime();
    this.__trackingTimeStart    = null;
    this.__isTrackingEngagement = false;
}

//
// Check engagement.
AdsNinjaVideoPlayerEngagementHelper.prototype.checkEngagement = function(){
    
    var engagementTime           = this.__getEngagementTime();
    var isTrackingNoLongerNeeded = (this.__getEngagementTime() >= this.__maxEngagementTimeTracked);

    if(isTrackingNoLongerNeeded || !this.isTabActive() || !this.isInView()){

        this.stopTracking();
    }
    else{

        this.startTracking();
    }

    var minimumMet = (engagementTime >= this.__minEngagementTimeTracked);

    if(minimumMet){

        // Check engegement thresholds.
        this.__checkEngagementThresholds();
    }
}

//
// Check engagement thresholds.
AdsNinjaVideoPlayerEngagementHelper.prototype.__checkEngagementThresholds = function(){
    
    for(var x in this.__engagementThesholds){
        
        var engagementTheshold = this.__engagementThesholds[x];

        if(engagementTheshold['time'] <= this.__getEngagementTime()){

            if(typeof this.__callback !== 'function'){

                break;
            }

            engagementTheshold['complete'] = true;

            this.__callback(engagementTheshold['time']);

            return;
        }
    }
}

//
// Get current engagement time.
AdsNinjaVideoPlayerEngagementHelper.prototype.__getCurrentEngagementTime = function(){
    
    if(!this.__isTrackingEngagement){

        return 0;
    }

    return (new Date() - this.__trackingTimeStart) / 1000;
}   

//
// Returns engagement time.
AdsNinjaVideoPlayerEngagementHelper.prototype.__getEngagementTime = function(){
    
    return this.__engagementTime + this.__getCurrentEngagementTime();
}

//
// Sets engagement thesholds.
AdsNinjaVideoPlayerEngagementHelper.prototype.__setEngagementThesholds = function(engagementThesholds){
    
    if(!Array.isArray(engagementThesholds) || engagementThesholds.length === 0){

        throw new Error('Invalid engagement thesholds provided.');
    }

    for(var x in engagementThesholds){
        
        engagementThesholds[x] = parseInt(engagementThesholds[x], 10);
    }

    engagementThesholds.sort(function(a, b){ 

        return a - b;
    });

    var first = true;

    for(var y in engagementThesholds){
        
        this.__engagementThesholds.push({ time: engagementThesholds[y], complete: false });

        this.__maxEngagementTimeTracked = engagementThesholds[y];

        if(first){

            this.__minEngagementTimeTracked = engagementThesholds[y];
            first                           = false;
        }
    }
}

//
// Returns true if the video is in view.
AdsNinjaVideoPlayerEngagementHelper.prototype.isInView = function(){

    var rect                     = this.__element.getBoundingClientRect();
    var percentageOfHeightInView = ((rect.height + rect.y)/rect.height) * 100;
    percentageOfHeightInView     = (isNaN(percentageOfHeightInView)) ? 0 : percentageOfHeightInView;
    var percentageOfWidthInView  = ((rect.width + rect.x)/rect.width) * 100;
    percentageOfWidthInView      = (isNaN(percentageOfWidthInView)) ? 0 : percentageOfWidthInView;

    // Calculate with percentages of ad in view.
    var isInView = (
        percentageOfHeightInView >= 50
        && percentageOfWidthInView >= 50
        && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

    return isInView;
};

//
// Returns true if the video is in view.
AdsNinjaVideoPlayerEngagementHelper.prototype.isTabActive = function(){

    return !document.hidden;
}

window.AdsNinjaVideoPlayerEngagementHelper = AdsNinjaVideoPlayerEngagementHelper;